<template>
<div>
	<div id="content">
		<div v-if="localQuestion !== null" class="question-card">
			<b-container class="bv-example-row">
				<b-row>
					<b-col cols="8">
						<div v-if="editMode"><b-form-input class="mb-2" v-model="localQuestion.text"></b-form-input></div>
						<div v-else><h5>{{localQuestion.text}}</h5></div>
						<p>Fact card name: Q_{{localQuestion.key}}</p> 
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="8">
						<p>Correct Quiz Answer: <br/><b-form-input class="mb-2" v-model="localQuestion.correctAnswer"></b-form-input></p>
						<b-col><b-button @click="handleEditBtnClick">{{editMode ? "Save" : "Edit"}}</b-button> </b-col>
						<b-col><div v-if="questionnaireId !== null"><b-button @click="handleCancelRemove" variant="danger">{{editMode ? "Cancel" : "Remove"}}</b-button> </div> </b-col>
					</b-col>
				</b-row>
				<div v-if="!editMode">
					<p>Answer type: {{switchAnswerType(question.questionType)}}</p>
					<div class="row-md-2" >
						<div v-for="a in localQuestion.possibleAnswers" :key="a.answerId"> 
							<p>{{a.answer.text}}</p>
						</div>
					</div> 
				</div>
				<div v-else>
					<b-form-group label="Answer type" v-slot="{ ariaDescribedby }">
						<b-form-checkbox-group
							v-model="questionType"
							:options="[0,1,2,3,4,5].map((e) => { return {text: switchAnswerType(e) + ' ', value: e}; })"
							:aria-describedby="ariaDescribedby"
							button-variant="primary"
							size="lg"
							name="buttons-2"
							>
						</b-form-checkbox-group>
					</b-form-group>
					<div class="col" v-if="localQuestion.questionType == 4 || localQuestion.questionType == 5">
						<p>Possible answers:</p>
						<b-button class="answerButton" v-for="e in this.localQuestion.possibleAnswers" :key="e.id" @click="removeAnswerFromQuestion(localQuestion, e)">
							<p>{{e.answer.text}}</p><p>(val: {{e.answer.value}})</p><b-icon icon="x-circle" font-scale="1.5"/>
						</b-button>
						<b-col>
							Text: <b-form-input class="mb-2" v-model="answerText"></b-form-input>Value:<b-form-input class="mb-2" v-model="answerValue"></b-form-input>
						</b-col>
						<b-col>
							<b-button @click="addAnswerToQuestion()"  variant="success">Add Answer</b-button>
						</b-col>
					</div>
				</div>
			</b-container>
		</div>
	</div>
</div>
</template>
<script>
export default {
  name: 'QuestionCard',
  props: {
	question: {
		type: Object,
		required: true
	},
	questionnaireId: {
		type: String, 
		required: false
	},
	initEditMode: {
		type: Boolean,
		required: false,
		default: false
	}
  },
  data() {
	return{
		createNewQuestion: false,
		editMode: false,
		answerText: null,
		correctAnswer: "",
		answerValue: null,
		delMethod: null,
		localQuestion: null
	}
  },
  computed: {
	questionType: {
		get() {
			return [this.localQuestion.questionType];
		},
		set(newValue) {
			var latest = newValue[newValue.length - 1];
			this.localQuestion.questionType = latest;
		}
	}
  },
  methods: {
	handleEditBtnClick: function() {
		if (this.editMode) {
			this.saveQuestion();
			this.editMode = false;
		}
		else {
			this.editMode = true;
		}
	},
	handleCancelRemove: function() {
		console.log("cancel remove question");
		console.log(this.localQuestion.text);
		if (this.editMode) {
			if (this.localQuestion.id == null || this.localQuestion.id == '') {
				this.$emit("cancelNewQuestion");
			}
			this.editMode = false;
			this.localQuestion = JSON.parse(JSON.stringify(this.$props.question));
		} else {
			if (this.$props.questionnaireId != null) {
				this.removeQuestionFromQuestionnaire();
			} else {
				
				this.$http.delete(this.$config.ApiUri + "/Questions/" + this.localQuestion.id)
				.then(() => {
					this.$emit("onChange");
					this.$emit("onMessage", "Deleted question");
				})
				.catch((e) => {
					console.log("Error deleting question");
					console.log(e);
					this.$emit("onError", e);
				});
			}
		}
	},
	saveQuestion: function(){
		if (this.localQuestion.id == null || this.localQuestion.id == "") {
			delete this.localQuestion.id;
			this.$http.post(this.$config.ApiUri + "/Questions", this.localQuestion)
				.then((result) => {
					this.localQuestion = result.data;
					var addToQuestionnaire = this.$props.questionnaireId != null || this.$props.questionnaireId != '';
					if (addToQuestionnaire) { //addToQuestionnaire was originally a bool param to this method
						this.addQuestionToQuestionnaire();
					}
					this.$emit("onCreateNew");
					this.$emit("onMessage", "Created question");
				}
			).catch((e) => {
				console.log("Error creating question");
				console.log(e);
				this.$emit("onError", e);
			});
		} else {
			this.$http.put(this.$config.ApiUri + "/Questions/" + this.localQuestion.id, this.localQuestion)
				.then((result) => {
					this.localQuestion = result.data;
					this.$emit("onChange");
					this.$emit("onMessage", "Updated question");
				}
			).catch((e) => { 
				console.log("Error saving question");
				console.log(e);
				this.$emit("onError", e);
			});
		}
	},
	// TODO: Separate out onChange and onCreateNew for rebuild purposes in parent
	addQuestionToQuestionnaire: function() {
		if (this.$props.questionnaireId != null && this.$props.questionnaireId != "") {
			if (this.localQuestion.id != null && this.localQuestion.id != "") {
				this.$http.post(this.$config.ApiUri + "/Questionnaires/" + this.$props.questionnaireId + "/QuestionnaireQuestions/" + this.localQuestion.id)
					.then(() => {
						this.$emit("onChange");
					}
				).catch((e) => { 
					console.log("Error adding question from questionnaire ");
					console.log(e);
					this.$emit("onError", e);
				});
			}
		} 
	},
	removeQuestionFromQuestionnaire: function() {
		if (this.$props.questionnaireId != null && this.$props.questionnaireId != "") {
			this.$http.delete(this.$config.ApiUri + "/Questionnaires/" + this.$props.questionnaireId + "/QuestionnaireQuestions/" + this.localQuestion.id)
				.then(() => {
					this.$emit("onChange");
					this.$emit("onMessage", "Removed question from questionnaire");
				}
			).catch((e) => { 
				console.log("Error removing question from questionnaire ");
				console.log(e);
				this.$emit("onError", e);
			});
		}
	},
	addAnswerToQuestion: function() {
		this.localQuestion.possibleAnswers.push({ "answer": { "text": this.answerText, "value": this.answerValue, "correctAnswer": this.correctAnswer}});
		this.answerText = null;
		this.answerValue = null;
		this.correctAnswer = null;
	},
	removeAnswerFromQuestion: function(qu, a) {
		var i = qu.possibleAnswers.indexOf(a);
		qu.possibleAnswers.splice(i, 1);
	},
	switchAnswerType(type) {
		switch(type) {
			case 0: return "Free text";
			case 1: return "Free text (number)";
			case 2: return "Free text (currency)";
			case 3: return "Free text (%)";
			case 4: return "Multiple choice";
			case 5: return "Dropdown";
			default: return "Unknown"
		}
	},
  },
  mounted: function() {
	this.localQuestion = JSON.parse(JSON.stringify(this.$props.question));
	this.editMode = this.$props.initEditMode;
  }
}
</script>

<style>
	.question-card {
		padding: 20px;
		margin-bottom: 20px;
		background-color:aliceblue;
	}
	.new-question-card {
		padding: 20px;
		margin-bottom: 20px;
		background-color:aliceblue;
	}
	.card2 {
		padding: 20px;
		margin: 20px;
		background-color:white;
	}
	.activeBtn {
	background: rgb(243, 16, 0) !important;
	}
	.answerButton {
		background: grey;
		font-size: 4px;
		margin: 2px;
	}
</style>